// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1385":"822989d6","6057":"16b97820","7337":"822989d6","7414":"822989d6","9172":"822989d6","9251":"822989d6"}[chunkId] + ".chunk.css";
};